// Discord Server Configuration
// Update this link when the invite changes

export const DISCORD_INVITE_URL = "https://discord.gg/TK8T2yAMZd";
export const DISCORD_SERVER_NAME = "ExamDex Community";

// For use in components
export const getDiscordInviteUrl = () => DISCORD_INVITE_URL;
